import { render, staticRenderFns } from "./index.vue?vue&type=template&id=06e78664&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=06e78664&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e78664",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryCard: require('/workspace/components/CategorySection/CategoryCard.vue').default,ShimmerEffect: require('/workspace/components/ShimmerEffect.vue').default,PlaceCard: require('/workspace/components/PlaceCard.vue').default,ShimmerEffectMultiple: require('/workspace/components/ShimmerEffectMultiple.vue').default})
